import { CanvasPosition, CanvasPositionMap } from "../types/canvas.types";
import { nodeDefs } from "src/nodes";
import { createTreeFromPositions } from "src/features/tree";
import { NodeMap } from "src/types/node.types";
import { Tree } from "src/types/tree.types";

export function createPositionsFromTree(tree: Tree): CanvasPositionMap {
  return Object.fromEntries<CanvasPosition>(
    tree.nodes.map((treeNode, idx) => [
      treeNode.node.id,
      { nodeId: treeNode.node.id, x: treeNode.indent, y: idx },
    ])
  );
}

export function getLocationForNewNode(
  positions: CanvasPositionMap,
  nodes: NodeMap
): {
  x: number;
  y: number;
} {
  const tree = createTreeFromPositions(positions, nodes);

  if (tree.nodes.length === 0) return { x: 0, y: 0 };

  const last = (() => {
    const treeNode = tree.nodes[tree.nodes.length - 1];
    const position = positions[treeNode.node.id];
    return { treeNode, position };
  })();

  const lastActive = (() => {
    const reversedNodes = tree.nodes.slice().reverse();
    const treeNode = reversedNodes.find((treeNode) => treeNode.isActive);

    if (!treeNode) return undefined;

    const node = treeNode.node;
    const nodeDef = nodeDefs[node.type];
    const position = positions[node.id];
    return { treeNode, node, nodeDef, position };
  })();

  const y = last.position.y + 1;
  const x = lastActive
    ? lastActive.nodeDef.acceptsChildren
      ? lastActive.position.x + 1 // position as child
      : lastActive.position.x // position as sibling
    : 0;

  return { x, y };
}
